import { useGetBrandLazyQuery } from 'src/graphql/generated';

export const useBrandLazyQuery = (brandId: string | null) => {
  const [getBrandQuery] = useGetBrandLazyQuery({
    variables: {
      id: brandId!,
    },
    fetchPolicy: 'cache-first',
  });

  return [getBrandQuery];
};
